import azores from './azores.jpg';
import bora from './bora.jpg';
import crete from './crete.jpg';
import lucia from './lucia.jpg';
import nz from './nz.jpg';
import ber from './ber.jpg';
import thew from './thew.jpg';
import cook from './cook.jpg';
import taz from './taz.jpg';
import bali from './bali.jpg';

export const data= [

    {
        id: 1,
        image: azores,
        name: "Azores",
        description: "The Azores are a magical archipelago in the mid-Atlantic and part of Portugal. Dramatic landscapes filled with massive cliffs emerging from hypnotizing waters, endless hedgerows of blue hydrangea, an abundance of wildlife, and beautiful waterfalls, this secluded stretch of islands is a must-visit.",
        showMore: false, 
    },

    {
        id: 2,
        image: bora,
        name: "Bora Bora",
        description: "Out of all the incredible islands that comprise French Polynesia, Bora Bora is the crown jewel. Just northwest of Tahiti, the island feels utterly remote while being easily accessible for the honeymoon, anniversary, or celebratory trip of dreams. Surrounded by a coral reef-protected lagoon, Bora Bora is a popular destination for scuba divers and snorkelers alike, and it boasts an array of world-class luxury resort properties." ,
        showMore: false, 
    },

    {
        id: 3,
        image: crete,
        name: "Crete",
        description: "Thanks to Greek mythology, Crete has been immortalized as a mystical island that was the birthplace of King Zeus. Besides history and folklore, Crete offers some of the world's most swoon-worthy beaches and views of the Aegean." ,
        showMore: false, 
    },

    {
        id: 4,
        image: lucia,
        name: "St. Lucia",
        description: "This glorious island in the Eastern Caribbean might surprise first-time visitors by how much it resembles a Hawaiian island. This charming destination features an abundance of terrain, from the aptly named, iconic Sugar Beach to the stunning Piton volcanic mountains. Visitors can always expect thoughtful hospitality, a taste of the French-inspired Caribbean culture, and mystical views.",
        showMore: false, 
    },
    
    {
        id: 5,
        image: nz ,
        name: "New Zealand" ,
        description: "This magical island-country is full of fantastical changes in terrain, folklore-ish caves and coves, and breathtaking beaches. One of the most popular sights is Milford Sound, shown here, which is a magnificent fjord home to rainforests, waterfalls, black coral, and fascinating aquatic life (think: penguins).",
        showMore: false, 
    },

    {
        id: 6,
        image: ber,
        name: "Bermuda",
        description:"Known for its pink-sand beaches, friendly culture, and obsession with rum, Bermuda is as vibrant as it is beautiful. This British territory lies in the Northern Atlantic and offers iconic beaches, plenty of natural wonders to explore, and breathtaking waters." ,
        showMore: false, 
    },

    {
        id: 7,
        image: thew ,
        name: "The Whitsundays",
        description: "The Whitsundays lie right off Queensland in the heart of the Great Barrier Reef, so prepare for strapping on that snorkel or scuba gear upon arrival. Home to 74 island wonders, this region of Australia is home to some of the world's best beaches, like Whitehaven Beach.",
        showMore: false, 
    },

    {
        id: 8,
        image:cook ,
        name: "Cook Islands",
        description: "This South Pacific nation consists of 15 islands and is politically tied to New Zealand. This year-round paradise offers sweeping stretches of coconut palms (no hotels can be taller than them!), piercing blue waters, and spectacular marine life.",
        showMore: false, 
    },

    {
        id: 9,
        image: taz ,
        name: "Tazmania" ,
        description: "This island-state seated just below Australia is wild, rustic, and geographically diverse, as nearly 40 percent of the island is protected for national parks and national heritage wilderness. White sand beaches with sweeping ocean and mountain views are a hallmark of Tasmania, making it an ultimate destination for island getaways." ,
        showMore: false, 
    },

    {
        id: 10,
        image: bali ,
        name: "Bali",
        description: "Bali is the most popular of Indonesia's enchanting islands, thanks to its paradisal terrain, fascinating history and architecture, renowned wellness experiences, and, of course, some of the best stretches of beach in the world. Turquoise waters, bright white sands, and verdant rock formations make for an ideal place to surf, swim, and sunbathe." ,
        showMore: false, 
    }

]
